// Utility function to detect if an image is a PNG with alpha
export const detectPngWithAlpha = (imageData: string): boolean => {
  if (!imageData) return false;
  
  // If it's a URL, check file extension
  if (imageData.startsWith('http://') || imageData.startsWith('https://')) {
    const url = imageData.toLowerCase();
    // PNG files are more likely to have alpha, so use contain for better visual results
    return url.includes('.png') || url.includes('.webp');
  }
  
  // For base64 data, check if it's a PNG
  if (imageData.startsWith('iVBORw0KGgo')) {
    // This is a PNG base64 signature
    return true;
  }
  
  // For data URLs
  if (imageData.startsWith('data:image/png') || imageData.startsWith('data:image/webp')) {
    return true;
  }
  
  // For other image types (JPEG, GIF), use cover
  return false;
};

// Get appropriate object-fit class based on image type
export const getImageObjectFit = (imageData: string): string => {
  return detectPngWithAlpha(imageData) ? 'object-contain' : 'object-cover';
};

// Get appropriate background class based on image type
export const getImageBackground = (imageData: string): string => {
  return detectPngWithAlpha(imageData) 
    ? 'bg-gradient-to-br from-gray-800/30 to-gray-900/30' 
    : 'bg-white/5';
};

// Get appropriate padding based on image type (for non-carousel use)
export const getImagePadding = (imageData: string): string => {
  return detectPngWithAlpha(imageData) ? 'p-6' : 'p-4';
}; 